// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptKey: __t.string().primaryKey().name("receipt_key"),
  target: __t.identity(),
  life: __t.u32(),
  attacker: __t.identity(),
  attackerKey: __t.string().name("attacker_key"),
  contextKind: __t.string().name("context_kind"),
  contextId: __t.u64().name("context_id"),
  worldId: __t.u64().name("world_id"),
  at: __t.timestamp(),
});
